import { render, staticRenderFns } from "./ApprovalConfigForm.vue?vue&type=template&id=67e81a5b&scoped=true"
import script from "./ApprovalConfigForm.vue?vue&type=script&lang=js"
export * from "./ApprovalConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfigForm.vue?vue&type=style&index=0&id=67e81a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e81a5b",
  null
  
)

export default component.exports